import { createUseStyles } from 'react-jss'

import { lightGrey } from '../../../../../styles/const/colors'

const useStyles = createUseStyles({
  adCard: {
    width: '100%',
    maxWidth: 243,
    border: `1px solid ${lightGrey}`,
    margin: '0 auto',
    backgroundColor: '#fff',
    overflow: 'hidden',
    marginBottom: 20,
    wordWrap: 'break-word',
    boxSizing: 'border-box',
    fontFamily: 'Roboto, sans-serif',
    '& p': {
      marginTop: 0
    }
  }
})

export default useStyles
